import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnInit
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";

@Component({
    selector: "app-dialog-confirmation-mobile",
    imports: [SharedMaterialModule],
    templateUrl: "./dialog-confirmation-mobile.component.html",
    styleUrl: "./dialog-confirmation-mobile.component.scss"
})
export class DialogConfirmationMobileComponent implements OnInit {
    readonly dialogRef = inject(
        MatDialogRef<DialogConfirmationMobileComponent>
    );
    readonly data = inject(MAT_DIALOG_DATA) as DialogConfirmationMobileData;

    ngOnInit(): void {}

    public handleOptionClick(option: DialogConfirmationMobileOptions): void {
        this.dialogRef.close(option.value);
    }
}

type DialogConfirmationMobileData = {
    options: DialogConfirmationMobileOptions[];
};

type DialogConfirmationMobileOptions = {
    label: string;
    value: string;
    alert?: boolean;
};
